import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { QueryClient } from '@tanstack/angular-query-experimental';
import { finalize } from 'rxjs';

const READS = new Set(['GET', 'HEAD', 'OPTIONS']);
/** Session plumbing (token refresh, CSRF, login): never a change to business data. */
const SESSION_PATHS = ['/authentication/', '/public/csrf'];

/**
 * Marks every cached query as stale once a write (POST, PUT, PATCH, DELETE) has gone through, whatever it changed:
 * the queries on screen reload in the background, the others on their next use. Simpler and safer than listing which
 * write changes which data. Done when the write ends, failed or not, since a failed write may still have changed
 * something.
 */
export const invalidateOnWriteInterceptor: HttpInterceptorFn = (req, next) => {
  if (READS.has(req.method.toUpperCase()) || SESSION_PATHS.some((path) => req.url.includes(path))) {
    return next(req);
  }
  const queryClient = inject(QueryClient);
  return next(req).pipe(finalize(() => void queryClient.invalidateQueries()));
};
